export const LOADING_TIME_FOR_GAMES__NOT_INTEGRATED = 3000;
